<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineProps({
  lookup: Object
});

const details = {
  [t('lookup.dns.ttl')]: 'ttl',
  [t('lookup.dns.registered_domain')]: 'full_domain',
  [t('lookup.dns.primary_nameserver')]: 'master_name',
  [t('lookup.dns.admin')]: 'admin_email',
  [t('lookup.dns.serial')]: 'serial',
  [t('lookup.dns.refresh_ttl')]: 'refresh_ttl',
  [t('lookup.dns.retry_ttl')]: 'retry_ttl',
  [t('lookup.dns.expire_ttl')]: 'expire_ttl',
  [t('lookup.dns.minimum_ttl')]: 'min_ttl'
};
</script>

<template>
  <div>
    <div class="mb-2 flex justify-between gap-2 md:justify-normal md:gap-0">
      <div class="font-bold md:w-2/12">
        {{ $t('lookup.partials.dns.card_detail_soa.rdtype') }}
      </div>
      <div class="flex items-center gap-2">SOA</div>
    </div>
    <div
      v-for="(value, key) in details"
      :key="key"
      class="mb-2 flex justify-between gap-2 md:justify-normal md:gap-0"
    >
      <div class="font-bold md:w-2/12">{{ key }}:</div>
      <div class="flex items-center gap-2">{{ lookup[value] }}</div>
    </div>
  </div>
</template>
